import { css } from '@emotion/react'
import { colors, InfoLabel, Text, VFlow } from 'bold-ui'
import { simNaoEnumRecord } from 'components/form'
import { HLabel } from 'components/HLabel'
import { formatCiapCid } from 'view/cuidados-compartilhados/util-cuidadoCompartilhado'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { TipoCompartilhamentoCuidadoPlanoEnum } from '../../cuidado-compartilhado/model-cuidadocompartilhado'
import { CompartilhamentoCuidadoPlanoModel } from '../model-compartilhamentocuidado'

interface CompartilhamentoCuidadoTablePanelProps {
  row: CompartilhamentoCuidadoPlanoModel
}

export const CompartilhamentoCuidadoTablePanel = (props: CompartilhamentoCuidadoTablePanelProps) => {
  const {
    row: { problemasECondicoes, discussao, lotacaoSolicitante, cbo, cidadaoAceitaAtendTic, tipo },
  } = props

  return (
    <VFlow vSpacing={0.5} style={styles.panel}>
      <InfoLabel title='CBO'>
        <Text>{cbo.nome.capitalize()}</Text>
      </InfoLabel>

      <InfoLabel title='Problemas/condições'>
        <Text>{formatCiapCid(problemasECondicoes.ciap, problemasECondicoes.cid10)}</Text>
      </InfoLabel>

      <InfoLabel title='Discussão'>
        <Text dangerouslySetInnerHTML={{ __html: discussao }} style={styles.discussao} />
      </InfoLabel>

      {tipo === TipoCompartilhamentoCuidadoPlanoEnum.CUIDADO_COMPARTILHADO && (
        <InfoLabel title='Após devida explicação, o cidadão declara concordar de forma livre e esclarecida que o agendamento da consulta com o especialista poderá ser mediado por tecnologia?'>
          <Text>{simNaoEnumRecord[cidadaoAceitaAtendTic]}</Text>
        </InfoLabel>
      )}

      <HLabel title='Adicionado por:'>
        <Text>
          {formatNomeProfissional(lotacaoSolicitante.profissional)} - {lotacaoSolicitante.cbo.nome}
        </Text>
      </HLabel>
    </VFlow>
  )
}

const styles = {
  panel: css`
    padding: 1rem;
    background: ${colors.gray.c90};
  `,
  discussao: css`
    word-break: break-all;
  `,
}
